import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';

import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type SetUserSuccessResponseType = { message: string };
export type SetTempPasswordPayload = Partial<{
	password: string;
}>;

async function setTempPassword(
	id: string,
	payload: SetTempPasswordPayload,
): Promise<SetUserSuccessResponseType | null> {
	const response = await axios.put(`${API_URLS.USERS.TEMP_PASSWORD(id)}`, payload);
	return getResponse<SetUserSuccessResponseType>(response.data);
}

export type SetTempPasswordPayloadType = {
	id: string;
	payload: SetTempPasswordPayload;
};

export function setTempPasswordOptions() {
	return mutationOptions({
		mutationFn: ({ id, payload }: SetTempPasswordPayloadType) => setTempPassword(id, payload),
		onSuccess: async (data) => {
			console.log('Temporary password set successfully:', data);
			toast.success(t('admin.toast.tempPasswordSet'));
			await queryClient.invalidateQueries({ queryKey: ['users'] });
		},
		onError: (error) => toastApiError(error),
	});
}
